"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function default_1(name, value) {
    var _a;
    if (typeof name !== 'object') {
        return tslib_1.__assign((_a = {}, _a[name] = value, _a));
    }
    return name;
}
exports.default = default_1;
//# sourceMappingURL=nameValueToObject.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/core/dependency-container/utils/nameValueToObject.js
// module id = 41
// module chunks = 0